<template>
  <q-btn
    color="red"
    icon="delete"
    style="margin-left: 5px;"
    @click="handleDataDelete"
  />
</template>

<script>
  import { mapGetters } from 'vuex';
  import {showSystemNotify} from "../utils";

  export default {
    name: "DeleteBtn",
    props: {
      DeleteAction: {
        type: String,
        required: true
      },
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['loginUser'])
    },
    methods: {
      handleDataDelete() {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要刪除此筆資料？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch(this.DeleteAction, this.id).then(res => {
            showSystemNotify(res)
            this.$router.go(this.$route.fullPath)
            // this.$router.push({
            //   path: this.$route.fullPath,
            //   query : { _time:new Date().getTime() / 1000 }
            // })
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>
